import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import BlankLayout from '../layouts/BlankLayout';
import SiderLayout from '../layouts/SiderLayout';
import LoadingPage from '../components/LoadingPage';
import { withLoading } from '../components/withLoading';

// 添加登录页面的懒加载导入
const Login = lazy(() => import('../pages/login/login'));

// 添加二维码页面的懒加载导入
const Qrcode = lazy(() => import('../pages/qrcode/qrcode'));

// 添加Facebook集成页面的懒加载导入
const Facebook = lazy(() => import('../pages/integration/facebook/facebook'));

// 添加集成平台页面的懒加载导入
const Integration = lazy(() => import('../pages/integration/integration'));

// 添加自动化流程页面的懒加载导入
const Automation = lazy(() => import('../pages/automation/automation'));

// 添加流程管理页面的懒加载导入
const Process = lazy(() => import('../pages/process/process'));

// 添加脚本库页面的懒加载导入
const ScriptLibrary = lazy(() => import('../pages/script-library/ScriptLibrary'));

// 添加任务计划页面的懒加载导入
const TaskPlan = lazy(() => import('../pages/task-plan/taskPlan'));
const CreateTaskPlan = lazy(() => import('../pages/task-plan/CreateTaskPlan'));

// 添加聊天消息页面的懒加载导入
const Message = lazy(() => import('../pages/message/message'));

// 添加错误边界组件
const ErrorBoundary = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h1>出错了！</h1>
      <p>抱歉，页面加载时发生错误。</p>
    </div>
  );
};

// 创建带 loading 的组件包装器
const withLoadingSuspense = Component => {
  const WrappedComponent = withLoading(Component);
  return (
    <Suspense fallback={<LoadingPage />}>
      <WrappedComponent />
    </Suspense>
  );
};

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <SiderLayout />,
      errorElement: <ErrorBoundary />,
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      },
      children: [
        {
          index: true,
          element: <Navigate to='/message' replace />,
        },
        {
          path: 'integration',
          children: [
            {
              index: true,
              element: withLoadingSuspense(Integration),
            },
            {
              path: 'facebook',
              element: withLoadingSuspense(Facebook),
            },
          ],
        },
        {
          path: 'automation',
          children: [
            {
              index: true,
              element: <Navigate to='/automation/list' replace />,
            },
            {
              path: 'list',
              element: withLoadingSuspense(Process),
            },
            {
              path: 'create',
              element: withLoadingSuspense(Automation),
            },
            {
              path: 'editor/:id',
              element: withLoadingSuspense(Automation),
            },
          ],
        },
        {
          path: 'process',
          element: withLoadingSuspense(Process),
        },
        {
          path: 'import-codes',
          element: withLoadingSuspense(Qrcode),
        },
        {
          path: 'script-library',
          element: withLoadingSuspense(ScriptLibrary),
        },
        {
          path: 'batch-task',
          children: [
            {
              index: true,
              element: withLoadingSuspense(TaskPlan),
            },
            {
              path: 'create',
              element: withLoadingSuspense(CreateTaskPlan),
            },
          ],
        },
        {
          path: 'message',
          element: withLoadingSuspense(Message),
        },
      ],
    },
    {
      path: '/user',
      element: <BlankLayout />,
      errorElement: <ErrorBoundary />,
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      },
      children: [
        {
          path: 'login',
          element: withLoadingSuspense(Login),
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/automation/list' replace />,
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);
